
import { useRoute } from 'vue-router'
import { computed, defineComponent, nextTick, onMounted, ref, reactive, toRefs, watch } from 'vue'
import { askApi } from '@/api/index'
import { useStore } from 'vuex'
export default defineComponent({
  props: {
    change: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  setup(props, context) {
    const route = useRoute()
    const store = useStore()
    const pageData: any = reactive({
      token: route.query.token,
      serverId: route.query.serverid || route.query.serverId
    })
    pageData.token = route.query.token
    watch(
      () => store.state.changeOptionalTime,
      () => {
        getzixuan()
      }
    )
    // 自选列表
    function getzixuan() {
      if (!pageData.token) return
      const data: any = {}
      data.data = new FormData()
      store.commit('setLoginInfo', {
        token: pageData.token,
        serverId: pageData.serverId
      })
      data.data.append('serverId', pageData.serverId)
      data.data.append('token', pageData.token)
      // data.data = {
      //   serverId: pageData.serverId,
      //   token: pageData.token
      // }
      const _data: any = {
        serverId: pageData.serverId,
        token: pageData.token
      }
      const _signature: any = []
      // for (const key of data.data.keys()) {
      //   _signature.push(data.data.get(key))
      // }
      for (const key in _data) {
        _signature.push(_data[key])
      }
      const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
      data.headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        timestamp: _time,
        signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
      }
      askApi.getgroupall(data).then((res: any) => {
        if (res.data) {
          store.commit('setOptionalShareslist', res.data)
        }
      })
    }
    getzixuan()
    return {
      ...toRefs(pageData)
    }
  }
})
